// @ts-nocheck

import * as Yup from 'yup'
import { messageHelper } from '../../../../utils/messageHelper'
import cpfValidate from '../../../../utils/cpfValidator'

export const validationSchema = Yup.object().shape({
  document: Yup.string()
    .required(messageHelper.yup.error.documentIsMandatory)
    .test(
      'document validation',
      messageHelper.yup.error.documentIsInvalid,
      (value) => {
        if (value) {
          return cpfValidate(value)
        }
        return false
      }
    )
})
